module.exports = __webpack_public_path__ + "static/media/dpi.ce780b8e.jpg";